/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SignedConfigResponse } from './signedConfigResponse';


export interface ConfigResponseSpec { 
    component_config?: Array<SignedConfigResponse>;
}

